var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25 7.91659C1.25 7.45635 1.6231 7.08325 2.08333 7.08325H17.9167C18.3769 7.08325 18.75 7.45635 18.75 7.91659V16.6666C18.75 17.5871 18.0038 18.3333 17.0833 18.3333H2.91667C1.9962 18.3333 1.25 17.5871 1.25 16.6666V7.91659ZM2.91667 8.74992V16.6666H17.0833V8.74992H2.91667Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25 3.74992C1.25 2.82944 1.99619 2.08325 2.91667 2.08325H17.0833C18.0038 2.08325 18.75 2.82945 18.75 3.74992V7.91659C18.75 8.37682 18.3769 8.74992 17.9167 8.74992H2.08333C1.6231 8.74992 1.25 8.37682 1.25 7.91659V3.74992ZM17.0833 3.74992H2.91667V7.08325H17.0833V3.74992Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66683 0.833252C7.12707 0.833252 7.50016 1.20635 7.50016 1.66659V4.99992C7.50016 5.46016 7.12707 5.83325 6.66683 5.83325C6.20659 5.83325 5.8335 5.46016 5.8335 4.99992V1.66659C5.8335 1.20635 6.20659 0.833252 6.66683 0.833252Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3333 0.833252C13.7936 0.833252 14.1667 1.20635 14.1667 1.66659V4.99992C14.1667 5.46016 13.7936 5.83325 13.3333 5.83325C12.8731 5.83325 12.5 5.46016 12.5 4.99992V1.66659C12.5 1.20635 12.8731 0.833252 13.3333 0.833252Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8335 14.1666C10.8335 13.7063 11.2066 13.3333 11.6668 13.3333H14.1668C14.6271 13.3333 15.0002 13.7063 15.0002 14.1666C15.0002 14.6268 14.6271 14.9999 14.1668 14.9999H11.6668C11.2066 14.9999 10.8335 14.6268 10.8335 14.1666Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 14.1666C5 13.7063 5.3731 13.3333 5.83333 13.3333H8.33333C8.79357 13.3333 9.16667 13.7063 9.16667 14.1666C9.16667 14.6268 8.79357 14.9999 8.33333 14.9999H5.83333C5.3731 14.9999 5 14.6268 5 14.1666Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8335 10.8333C10.8335 10.3731 11.2066 10 11.6668 10H14.1668C14.6271 10 15.0002 10.3731 15.0002 10.8333C15.0002 11.2936 14.6271 11.6667 14.1668 11.6667H11.6668C11.2066 11.6667 10.8335 11.2936 10.8335 10.8333Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 10.8333C5 10.3731 5.3731 10 5.83333 10H8.33333C8.79357 10 9.16667 10.3731 9.16667 10.8333C9.16667 11.2936 8.79357 11.6667 8.33333 11.6667H5.83333C5.3731 11.6667 5 11.2936 5 10.8333Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.cec1ad02fc8ada9c6e714ec042872733.svg";
export { ForwardRef as ReactComponent };